import { render, staticRenderFns } from "./pointcenter.vue?vue&type=template&id=6e7c09dd&scoped=true&"
import script from "./pointcenter.vue?vue&type=script&lang=js&"
export * from "./pointcenter.vue?vue&type=script&lang=js&"
import style0 from "./pointcenter.vue?vue&type=style&index=0&id=6e7c09dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7c09dd",
  null
  
)

export default component.exports